import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet-async";

export default function () {
  return (
    <>
      <Helmet>
        <title>Board Members | Gandhi Mandela Foundation</title>
        <meta
          name="description"
          content="Meet the dedicated board members of the Gandhi Mandela Foundation, committed to promoting peace, education, and human rights."
        />
      </Helmet>
      <Header />
      <div>
        <section className="page-header">
          <div className="container">
            <div className="breadcrumb">
              <a href="/">Home</a>
              <span>/</span>
              <span>Board Members</span>
            </div>
            <h1>Board Members</h1>
          </div>
        </section>
        {/* =========================
            BOARD MEMBERS
        ========================= */}
        <section className="board-members">
          <div className="container">
            <h2 className="section-title">BOARD MEMBERS</h2>
            <div className="members-grid">
              <div className="member-card">
                <div className="member-img">
                  <img src="img/members/Nandanji.jpg" alt="ADV. NANDAN JHA" />
                </div>
                <h3>ADV. NANDAN JHA</h3>
                <span>SECRETARY GENERAL</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/Acharya-Lokesh-Muni.jpg"
                    alt="ACHARYA LOKESH MUNI"
                  />
                </div>
                <h3>ACHARYA LOKESH MUNI</h3>
                <span>VICE CHAIRMAN</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/savita-singh.jpg"
                    alt="DR. SAVITA SINGH"
                  />
                </div>
                <h3>DR. SAVITA SINGH</h3>
                <span>VICE PRESIDENT</span>
              </div>
            </div>
          </div>
        </section>
        {/* =========================
            BOARD MEMBERS END
        ========================= */}
        {/* =========================
            JURY MEMBERS
        ========================= */}
        <section className="jury-members">
          <div className="container">
            <h2 className="section-title">JURY MEMBERS</h2>
            <div className="members-grid">
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/K.G.-BALAKRISHNAN.jpg"
                    alt="JUSTICE K.G. BALAKRISHNAN"
                  />
                </div>
                <h3>JUSTICE K.G. BALAKRISHNAN</h3>
                <span>
                  (FORMER CHIEF JUSTICE OF INDIA &amp; FORMER CHAIRMAN NHRC
                  INDIA)
                </span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/norma-lucia-pina.jpg"
                    alt="norma-lucia-pina"
                  />
                </div>
                <h3>NORMA LUCÍA PIÑA HERNÁNDEZ</h3>
                <span>(FORMER CHIEF JUSTICE OF THE MEXICAN SUPREME COURT)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/JUSTICE-DIPAK-MISRA.jpg"
                    alt="JUSTICE DIPAK MISRA"
                  />
                </div>
                <h3>JUSTICE DIPAK MISRA</h3>
                <span>(FORMER CHIEF JUSTICE OF INDIA)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/KEDARNATH-UPADHYAY.jpg"
                    alt="KEDARNATH-UPADHYAY"
                  />
                </div>
                <h3>KEDARNATH-UPADHYAY</h3>
                <span>
                  (FORMER CHIEF JUSTICE OF NEPAL &amp; FORMER CHAIRMAN NHRC
                  NEPAL)
                </span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/RIGOBERTA.png"
                    alt="RIGOBERTA MENCHÚ TUM"
                  />
                </div>
                <h5
                  style={{
                    marginTop: "10px",
                    marginBottom: "-12px",
                  }}
                >
                  Nobel Peace Prize Winner - 1992
                </h5>
                <h3>RIGOBERTA MENCHÚ TUM</h3>
                <span>(Guatemalan Human Rights Activist)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/GYAN-SUDHA-MISRA.jpg"
                    alt="GYAN-SUDHA-MISRA"
                  />
                </div>
                <h3>JUSTICE GYAN SUDHA MISRA</h3>
                <span>(FORMER JUDGE SUPREME COURT OF INDIA)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/MD-TAFAZZUL-ISLAM.jpg"
                    alt="MD TAFazzul Islam"
                  />
                </div>
                <h3>JUSTICE MD TAFAZZUL ISLAM</h3>
                <span>(FORMER CHIEF JUSTICE OF BANGLADESH)</span>
              </div>
            </div>
          </div>
        </section>
        {/* =========================
            JURY MEMBERS END
        ========================= */}
        {/* =========================
            INTERNATIONAL TEAM
        ========================= */}
        <section className="international-team">
          <div className="container">
            <h2 className="section-title">INTERNATIONAL TEAM</h2>
            <div className="members-grid">
              <div className="member-card">
                <div className="member-img">
                  <img src="img/members/indra.jpg" alt="INDRA P. KATTEL" />
                </div>
                <h3>INDRA P. KATTEL</h3>
                <span>(JT.DIRECTOR-INTERNATIONAL RELATIONS)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/DR.-MANUEL-GRANADOS-COVARRUBIAS.jpg"
                    alt="DR. MANUEL GRANADOS COVARRUBIAS"
                  />
                </div>
                <h3>DR. MANUEL GRANADOS COVARRUBIAS</h3>
                <span>(PRESIDENT, MEXICO)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/Stephen-Murray.jpg"
                    alt="STEPHEN MURRAY"
                  />
                </div>
                <h3>STEPHEN MURRAY</h3>
                <span>(PRESIDENT, LATIN AMERICA)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/Jose-Raul-Vaquero-Pulido.jpg"
                    alt="JOSÉ RAÚL VAQUERO PULIDO"
                  />
                </div>
                <h3>JOSÉ RAÚL VAQUERO PULIDO</h3>
                <span>(PRESIDENT, SPAIN)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img
                    src="img/members/agus-indra-udayana.jpg"
                    alt="AGUS INDRA UDAYANA"
                  />
                </div>
                <h3>AGUS INDRA UDAYANA</h3>
                <span>(PADMA SHRI, PRESIDENT, INDONESIA)</span>
              </div>
              <div className="member-card">
                <div className="member-img">
                  <img src="img/members/fransisco.jpeg" alt="FRANCISCO REYES" />
                </div>
                <h3>FRANCISCO REYES</h3>
                <span>(PRESIDENT, ITALY)</span>
              </div>
            </div>
          </div>
        </section>
        {/* =========================
            INTERNATIONAL TEAM END
        ========================= */}
        <Footer />
      </div>
    </>
  );
}
